<script setup lang="ts">
import type { BackRoute } from '@/stores/useRouterStore';

import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import KBtn from '@/components/btns/KBtn.vue';
import { useRouterStore } from '@/stores/useRouterStore';

// TODO
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const route = useRoute() || {}; // TODO mock useRoute
const routerStore = useRouterStore();

const backRoutes = ref<BackRoute[]>([]);
const to = ref<BackRoute | null>(null);

watch(
  () => routerStore.backRoutes,
  (newBackRoutes) => {
    backRoutes.value = newBackRoutes;
    if (!backRoutes.value[0]) {
      to.value = null;
      return;
    }
    if (backRoutes.value[0].name === route.name) {
      if (backRoutes.value[1]) {
        to.value = backRoutes.value[1];
      }
    } else {
      to.value = backRoutes.value[0];
    }
  },
  { immediate: true },
);

function handleClick(): void {
  if (!routerStore.isShiftBackRoute) {
    routerStore.enableIsShiftBackRoute();
  }
}
</script>

<template>
  <template v-if="to">
    <KBtn
      :class="$style.barBackBtnLink"
      variant="text"
      prepend-icon="mdi-keyboard-backspace"
      data-testid="barBackBtnLink"
      :to="to"
      @click="handleClick"
    >
      Back
    </KBtn>
  </template>
  <template v-else>
    <KBtn
      :class="$style.barBackBtnLink"
      variant="text"
      prepend-icon="mdi-keyboard-backspace"
      disabled
      data-testid="barBackBtnLink"
    >
      Back
    </KBtn>
  </template>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.barBackBtnLink {
  height: 100% !important;
  width: 100% !important;
}
</style>
